namespace $.$$ {

	const Side_menu = {
		flex: {
			basis: '18rem'
		},
		background: {
			color: $mol_theme.card,
		},
	} as const
	
	$mol_style_define( $shm_hitalama_map_book, {
		
		Widgets_visible: {
			position: 'absolute',
			top: '4rem',
			zIndex: $mol_layer.float,
			':hover': {
				zIndex: $mol_layer.float,
			},
			':focus': {
				zIndex: $mol_layer.float,
			},
		},

		Page: {
			backgroundColor: 'transparent',
			flex: {
				grow: 1,
				basis: '20rem',
			},
		},

		Head: {
			width: '18rem',
		},

		Widgets: {
			...Side_menu,
			margin: {
				top: '4rem',
			},
		},
		
	} )
	
}
